import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a bedside table (0.45 x 0.4 x 0.5): oak body, one walnut
// drawer front with a steel handle, slim matte-black legs.
const OAK = "#c8975a";
const WALNUT = "#7a5a3a";
const BLACK = "#2e2e30";
const STEEL = "#aab2b8";

export const nightstand = defineModel({
  id: "nightstand",
  batchId: "modern",
  name: "Nightstand",
  tags: ["modern", "interior", "furniture", "bedroom", "storage"],
  summary: "A small oak bedside table with one drawer.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // slim legs
      { geometry: new THREE.BoxGeometry(0.03, 0.12, 0.03), color: BLACK, position: [-0.19, 0.06, -0.16] },
      { geometry: new THREE.BoxGeometry(0.03, 0.12, 0.03), color: BLACK, position: [0.19, 0.06, -0.16] },
      { geometry: new THREE.BoxGeometry(0.03, 0.12, 0.03), color: BLACK, position: [-0.19, 0.06, 0.16] },
      { geometry: new THREE.BoxGeometry(0.03, 0.12, 0.03), color: BLACK, position: [0.19, 0.06, 0.16] },
      // body
      { geometry: new THREE.BoxGeometry(0.45, 0.34, 0.4), color: OAK, position: [0, 0.29, 0] },
      // top
      { geometry: new THREE.BoxGeometry(0.47, 0.04, 0.42), color: WALNUT, position: [0, 0.48, 0] },
      // drawer front + handle
      { geometry: new THREE.BoxGeometry(0.37, 0.16, 0.02), color: WALNUT, position: [0, 0.36, 0.21] },
      { geometry: new THREE.BoxGeometry(0.14, 0.02, 0.02), color: STEEL, position: [0, 0.36, 0.225] },
    ];
  },
  animations: [],
});
